enum TypeLigneMontant {
	PROP_DIR = 'Proposition directe',
	SAI_LIB = 'Saisie libre',
}

export default TypeLigneMontant;
